import React from 'react'
import {MdLocationPin, MdMyLocation, MdOutlineBrandingWatermark, MdOutlineEmail} from 'react-icons/md'
import {BsShop} from 'react-icons/bs'
import { Rating } from 'react-simple-star-rating'
import default_image_url from '../../../../redux/api/API'
import { useTranslation } from 'react-i18next'

const CompanyMainInfo = ({data}) => {
    const {t} = useTranslation();

    return (
        <div className='CompanyMainInfo'>
            <div className=' animate__animated animate__fadeInDown'>
                <div className='company-cover' style={{backgroundImage: data.profile.cover ? `url(${default_image_url}${data.profile.cover})` : 'url(/assets/img/company-3.png)' }}>
                    <div className='company-avatar'>
                    {data.profile.avatar ?
                        <img src={`${default_image_url}${data.profile.avatar}`} style={{objectFit: 'contain', height: 'auto', width: '70%', maxWidth: '100%'}} />
                    :
                        <img src='/assets/img/shop.png' style={{objectFit: 'contain', height: 'auto', width: '70%', maxWidth: '100%'}} />
                    }
                    </div>
                </div>
                <div className='company-header mb-3'>
                    <div className='col-md-8 col-12'>
                    <div className='col-md-10'>
                        <div className='comp_title'>
                            <div>
                                <h1> {data.profile && data.profile.title}</h1>
                                {data.saloon ? <h2> {t("hall")} {data.saloon.name} </h2>: ''}
                            </div>
                            {data.reviews ? 
                                <div>
                                    <span className='text-muted mx-1'>({data.reviews.count})</span>
                                    <Rating initialValue={data.reviews.score} size='22' readonly={true} fillColor='#ffe301' />
                                </div> 
                            : 
                                ''
                            }
                            </div>
                        </div>
                            {data.profile &&
                                <div className='comp_icons'>
                                    {data.profile.province ?
                                        <div className='comp_item'>
                                            <MdLocationPin size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{data.profile.province ? data.profile.province : ''} - {data.profile.city ? data.profile.city : ''} - {data.profile.zone ? data.profile.zone : ''}</h6>
                                                <span>{t("address")}</span>
                                            </div>
                                        </div>
                                    :
                                        <div className='comp_item'>
                                            <MdLocationPin size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{t("address")}</h6>
                                                <span>{t("address")}</span>
                                            </div>
                                        </div>
                                    }
                                    {data.profile.brand ?
                                        <div className='comp_item'>
                                            <MdOutlineBrandingWatermark size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{data.profile.brand ? data.profile.brand : ''}</h6>
                                                <span>{t("dashboard_nav_brand")}</span>
                                            </div>
                                        </div>
                                    :
                                        <div className='comp_item'>
                                            <MdOutlineBrandingWatermark size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{t("dashboard_nav_brand")}</h6>
                                                <span>{t("dashboard_nav_brand")}</span>
                                            </div>
                                        </div>
                                    }
                                    {data.profile.location ?
                                        <div className='comp_item'>
                                            <MdMyLocation size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{data.profile.location ? data.profile.location : ''}</h6>
                                                <span>{t("dashboard_nav_location")}</span>
                                            </div>
                                        </div>
                                    :
                                        <div className='comp_item'>
                                            <MdMyLocation size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{t("dashboard_nav_location")}</h6>
                                                <span>{t("dashboard_nav_location")}</span>
                                            </div>
                                        </div>
                                    }
                                    {data.profile.email ?
                                        <div className='comp_item'>
                                            <MdOutlineEmail size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{data.profile.email ? data.profile.email : ''}</h6>
                                                <span>{t("dashboard_nav_email")}</span>
                                            </div>
                                        </div>
                                    :
                                        <div className='comp_item'>
                                            <MdOutlineEmail size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{t("dashboard_nav_email")}</h6>
                                                <span>{t("dashboard_nav_email")}</span>
                                            </div>
                                        </div>
                                    }
                                    {data.category_products &&
                                        <div className='comp_item'>
                                            <BsShop size='1.8em' color='#693FEB' />
                                            <div>
                                                <h6>{data.category_products.length} {t("dashboard_nav_category")}</h6>
                                                <span>{t("dashboard_nav_category")}</span>
                                        </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    {/* <div className='col-md-6'>
                        <div className='video'></div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default CompanyMainInfo
